<template>
  <v-dialog
    content-class="select-integration-popup"
    :value="internalValue"
    :width="630"
    @keydown.esc="onCloseClick"
    @click:outside="onCloseClick"
  >
    <v-card class="popup-wrapper">
      <div class='select-integration-popup' v-if='hasIntegrationOptions'>
        <div class='select-integration-popup__title'>
          {{ $t('select.integration') }}
          <div class="close"
               @click="onCloseClick">
            X {{$t('newProject.esc')}}
          </div>
        </div>
        <div class='select-integration-popup__content'>
          <div class='select-integration-popup__content__select'>
            <v-autocomplete
              :items="integrationNamesByCategory"
              v-model="selectedIntegration"
              :rules="[rules.required]"
              dense
              outlined
              autofocus
              return-object
              allow-overflow
            />
          </div>
          <div class='select-integration-popup__content__buttons'>
            <v-btn small depressed class="cancel-button" @click="onCloseClick"> {{ $t('confirm.cancel') }} </v-btn>
            <v-btn class="save-button" @click="onSaveTagsClick">
              {{ $t('select.integration.save') }}
            </v-btn>
          </div>
        </div>
      </div>
      <div class='no-integrations-popup' v-else>
        <div class='no-integrations-popup__title'>
          {{ $t('select.integration') }}
          <div class="close"
               @click="onCloseClick">
            X {{$t('newProject.esc')}}
          </div>
        </div>
        <div class='no-integrations-popup__content'>
          <div class='no-integrations-popup__content__message'>
            {{ $t('select.integration.no.integrations.message') }}
          </div>
          <div class='no-integrations-popup__content__buttons'>
            <v-btn class="save-button" @click="onCloseClick">
              {{ $t('select.integration.ok') }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

import { rules } from '@/utils/validationUtils';
import { mapGetters } from 'vuex';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectIntegrationPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    website: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      selectedIntegration: '',
    };
  },
  watch: {
    website() {
      if (this.website.integration) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedIntegration = this.integrationsByCategory.filter(item => item.name === this.website.integration).map(item => item.metaData.displayName)[0];
      }
    },
  },
  methods: {
    async onSaveTagsClick() {
      if (this.selectedIntegration.length > 0) {
        this.selectedIntegration = this.integrationsByCategory.find(({ metaData: { displayName } }) => displayName === this.selectedIntegration)?.name;
        await this.$emit('submitSelectedIntegration', this.selectedIntegration);
        this.onCloseClick();
      }
    },
    onCloseClick() {
      this.$emit('toggleSelectIntegrationPopup');
      this.selectedIntegration = '';
    },
  },
  computed: {
    ...mapGetters(['integrationsByCategory']),
    hasIntegrationOptions() {
      return this.integrationsByCategory?.length > 0;
    },
    integrationNamesByCategory() {
      return this.integrationsByCategory.map(integration => integration.metaData.displayName);
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    rules() {
      return rules;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  .add-tags-popup {
    .v-chip.v-chip--outlined.v-chip.v-chip {
      background-color: var(--tag-chip-bg, #f0f0f0);
      border-color: transparent;
      padding: rem(5);
      font-size: $font-size-sm;
    }

    .v-chip.v-chip--outlined .v-icon {
      font-size: $font-size-base;
      color: var(--text-primary);
    }
  }
}
</style>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(630);
  padding: $space-8 $space-10;

  .no-integrations-popup {
    &__title {
      text-transform: uppercase;
      color: var(--text-primary);
      font-size: $font-size-base;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $space-4;
      margin-bottom: $space-4;

      .close {
        float: right;
        cursor: pointer;
        margin-left: $space-5;
        text-align: right;
        font-size: $font-size-sm;
        text-transform: uppercase;
        text-decoration: none;
        height: $space-4;
        color: var(--brand-secondary);
        font-family: $default-application-font-medium;
        font-weight: 500;
        letter-spacing: 1.1px;
        line-height: $space-4;
      }
    }

    &__content {
      &__buttons {
        text-align: right;
        padding-top: $space-7;

        .message {
          font-size: $font-size-base;
          font-weight: normal;
          color: var(--text-primary);
          letter-spacing: 0;
          line-height: $space-4;
        }

        .save-button {
          height: $btn-height-md;
          border-radius: $radius-sm;
          background-color: var(--brand-primary);
          box-shadow: $shadow-sm;
          color: var(--text-inverse);
          font-size: $font-size-sm;
          font-weight: 500;
          letter-spacing: 1.07px;
          line-height: $space-4;
          text-align: center;
          margin-left: $space-2;
        }
      }
    }
  }

  .select-integration-popup {
    &__title {
      text-transform: uppercase;
      color: var(--text-primary);
      font-size: $font-size-base;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $space-4;
      margin-bottom: $space-4;

      .close {
        float: right;
        cursor: pointer;
        margin-left: $space-5;
        text-align: right;
        font-size: $font-size-sm;
        text-transform: uppercase;
        text-decoration: none;
        height: $space-4;
        color: var(--brand-secondary);
        font-family: $default-application-font-medium;
        font-weight: 500;
        letter-spacing: 1.1px;
        line-height: $space-4;
      }
    }

    &__content {
      &__buttons {
        text-align: right;
        padding-top: $space-7;

        .cancel-button {
          box-sizing: border-box;
          height: $btn-height-md;
          width: rem(86);
          border: $border-width-thin solid var(--brand-primary);
          color: var(--brand-primary);
          border-radius: $radius-sm;
          background-color: var(--bg-primary);
          box-shadow: $shadow-sm;
        }

        .save-button {
          height: $btn-height-md;
          border-radius: $radius-sm;
          background-color: var(--brand-primary);
          box-shadow: $shadow-sm;
          color: var(--text-inverse);
          font-size: $font-size-sm;
          font-weight: 500;
          letter-spacing: 1.07px;
          line-height: $space-4;
          text-align: center;
          margin-left: $space-2;
        }
      }
    }
  }
}
</style>
